/* global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { Map } from 'immutable';

export default class Icon extends Component {
  static propTypes = {
    icon: PropTypes.instanceOf(Map),
    toggleSelectIconModal: PropTypes.func,
    pageType: PropTypes.string
  }

  constructor(props) {
    super(props);

    this._callback = this._callback.bind(this);
  }

  _callback() {
    const { toggleSelectIconModal } = this.props;

    toggleSelectIconModal();
  }

  render() {
    const { icon, pageType } = this.props;

    switch (icon) {
      case null:
      case undefined: {
        let defaultIcon = '';

        switch (pageType) {
          case 'report':
            defaultIcon = 'fa fa fa-file-text-o';
            break;
          case 'element':
            defaultIcon = 'icomoon icon-element svg-icon';
            break;
          case 'elementType':
            defaultIcon = 'icomoon icon-element-type svg-icon';
            break;
          case 'view':
            defaultIcon = 'icomoon icon-views svg-icon';
            break;
          case 'relationshipType':
            defaultIcon = 'icomoon icon-rel-type svg-icon';
            break;
          default:
            break;
        }
        return (<i
          style={{
            float: 'left',
            marginRight: 10
          }}
          className={defaultIcon}
          onClick={this._callback}
        >
        </i>);
      }
      default:
        return (<img
          alt=""
          className="svg-icon"
          style={{
            float: 'left',
            marginRight: 10,
            height: 35,
            fill: 'red'
          }}
          src={require(`../static/icons/${icon.get('name')}.svg`)}
          onClick={this._callback}
        />);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Icon.js